import { schema } from 'normalizr'

const ContactSchema = new schema.Entity('contacts')

export default ContactSchema
